module.exports = __webpack_public_path__ + "static/media/conveyorbelt.55427146.jpg";